// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.text-field-container-XlFfG {
  width: 260px;
}

.text-field-label-OUy18 {
  display: block;
  font-size: 14px;
  color: var(--color-neutral-800);
  margin-bottom: 8px;
}

.text-field-inputContainer-R67F7 {
  display: flex;
  gap: 8px;
  width: 100%;
  height: 44px;
  background-color: white;
  overflow: hidden;
  border: 1px solid var(--color-neutral-300);
  border-radius: var(--radius-lg);
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  padding: 0px 12px;
}

.text-field-inputContainer-R67F7:focus-within { 
  border-color: var(--color-neutral-800);
  box-shadow: 0 0 0 0.5px var(--color-neutral-800);
}

.text-field-input-xQEBI {
  height: 100%;
  width: 100%;
  display: block;
  font-size: 15px;
  font-family: Roboto;
  border: none;
  outline: none;
  padding: 0px;
}

.text-field-input-xQEBI::placeholder {
  color: var(--color-neutral-500);
}

.text-field-iconContainer-UDVIg {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: var(--color-neutral-700);
}

.text-field-iconContainer-UDVIg > div {
  --size: 20px;
}

.text-field-hint-LGUC5 {
  font-size: 14px;
  margin-top: 16px;
  margin-left: 4px;
}

.text-field-error-msmCT {
  margin-left: 2px;
}
`, "",{"version":3,"sources":["webpack://./../core/src/components/text-field/text-field.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,0CAA0C;EAC1C,+BAA+B;EAC/B,wDAAwD;EACxD,iBAAiB;AACnB;;AAEA;EACE,sCAAsC;EACtC,gDAAgD;AAClD;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,YAAY;AACd;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".container {\n  width: 260px;\n}\n\n.label {\n  display: block;\n  font-size: 14px;\n  color: var(--color-neutral-800);\n  margin-bottom: 8px;\n}\n\n.inputContainer {\n  display: flex;\n  gap: 8px;\n  width: 100%;\n  height: 44px;\n  background-color: white;\n  overflow: hidden;\n  border: 1px solid var(--color-neutral-300);\n  border-radius: var(--radius-lg);\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n  padding: 0px 12px;\n}\n\n.inputContainer:focus-within { \n  border-color: var(--color-neutral-800);\n  box-shadow: 0 0 0 0.5px var(--color-neutral-800);\n}\n\n.input {\n  height: 100%;\n  width: 100%;\n  display: block;\n  font-size: 15px;\n  font-family: Roboto;\n  border: none;\n  outline: none;\n  padding: 0px;\n}\n\n.input::placeholder {\n  color: var(--color-neutral-500);\n}\n\n.iconContainer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  color: var(--color-neutral-700);\n}\n\n.iconContainer > div {\n  --size: 20px;\n}\n\n.hint {\n  font-size: 14px;\n  margin-top: 16px;\n  margin-left: 4px;\n}\n\n.error {\n  margin-left: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `text-field-container-XlFfG`,
	"label": `text-field-label-OUy18`,
	"inputContainer": `text-field-inputContainer-R67F7`,
	"input": `text-field-input-xQEBI`,
	"iconContainer": `text-field-iconContainer-UDVIg`,
	"hint": `text-field-hint-LGUC5`,
	"error": `text-field-error-msmCT`
};
export default ___CSS_LOADER_EXPORT___;
